---
en:
  admin:
    market_prices:
      empty_state: No market price data for this selection.
      errors:
        generic: Unable to load market price data.
      filters:
        date: Date
        month: Month
        price_area: Price area
        week_label_placeholder: Select a week
        week_start: Week starting
        year: Year
      missing_hours:
        caption_clear: All {total} expected hours present
        caption_missing: "{missing} of {total} expected hours missing"
        range_display: "{start} – {end}"
        row_caption:
          one: "{count} missing hour"
          other: "{count} missing hours"
        title: Missing hours
        value_clear: All clear
        value_missing:
          one: "{count} missing hour"
          other: "{count} missing hours"
        view_day: View day
      modes:
        day: Day
        month: Month
        week: Week
      summary:
        coverage_caption: "{present} / {total} hours present"
        coverage_label: Coverage
        missing_caption_unknown: Missing hours not available.
        missing_label: Missing hours
        missing_value_unknown: "—"
        price_range: Min {min} · Max {max}
      table:
        elspot_eur: Elspot EUR
        elspot_nok: Elspot NOK
        hour: Hour
        no_value: "–"
        timestamp: Timestamp
      timeline:
        coverage_caption: "{present} of {total} hours present"
        coverage_value: "{percent}% coverage"
        gaps_detected: Gaps detected
        missing_caption:
          one: "{count} missing hour"
          other: "{count} missing hours"
        prompt_select_day: Select a day from the timeline to inspect hourly details.
        title: Coverage timeline
      timezone_label: Timezone · {timezone}
      title: Market prices
